//---------------------------\\
//--- Fonctions générales ---\\
//---------------------------\\

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Dans ce fichier on retrouve les fonctions générales qu'on ne peut pas vraiment catégoriser
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// Importation ----------------------------------------------------------------------------------------------------
import $ from 'jquery'
import Scrollbar from 'smooth-scrollbar'
//-----------------------------------------------------------------------------------------------------------------


// Fonction initialisant les tiroirs
export function rubrics() {
  $('.rubrics > li .toggle').on('click', function() {
    var ouvert = $(this).parent().hasClass('open')
    $('.rubrics li.open .rubric').animate({ height: 'hide' }, { duration: 1000, specialEasing: { height: 'easeOutExpo' }})
    $('.rubrics li.open').removeClass('open')
    if (!ouvert) {
      var chosen = this
      setTimeout(function() { $(chosen).parent().addClass('open') }, 0)
      $('.rubric', $(this).parent()).stop(true, false).animate({ height: 'show' }, { duration: 1000, specialEasing: { height: 'easeOutExpo' }})
    }
    return false
  })
}


// Fonction permettant de défiller d'un block à un autre à l'aide d'un clique
export function scrollToBlock(depart, destination, duration, offset) {
  // Paramètres optionnels
  duration = (typeof duration === 'undefined') ? 600 : duration
  offset   = (typeof offset   === 'undefined') ? 0   : offset

  // Défilement au clique
  $(depart).on( 'click', function() {
    if($(window).width() <= 1024) offset = 0

    if(Scrollbar.has(document.querySelector('[data-mainScrollbar]'))) {
      window.mainScrollbar.scrollTo(0, ( destination != '' ? ($(destination).offset().top + window.mainScrollbar.offset.y) + offset : 0), 600)
    } else {
      $('html, body').animate({ scrollTop: ( destination != '' ? $(destination).offset().top + offset : 0 ) }, duration, 'easeInOutExpo')
    }
  })
}

export function scrollTo(destination, duration, offset) {
  duration = (typeof duration === 'undefined') ? 600 : duration
  offset   = (typeof offset   === 'undefined') ? 0   : offset

  if($(window).width() <= 1024) offset = 0
  if(Scrollbar.has(document.querySelector('[data-mainScrollbar]'))) {
    window.mainScrollbar.scrollTo(0, ( destination != '' ? ($(destination).offset().top + window.mainScrollbar.offset.y) + offset : 0), 600)
  } else {
    $('html, body').animate({ scrollTop: ( destination != '' ? $(destination).offset().top + offset : 0 ) }, duration, 'easeInOutExpo')
  }
}

// Fonction gèrant l'alerte
export function alert() {
  $('.alertBlock .close').on('click', () => {
    $('html').removeClass('showOverlayAlert')
  })
}


// Fonction gèrant la hauteur du block twoCol en fonction du sideNav
export function sideNav() {
  var sideNavHeight

  var getHeight = () => {
    var imageHeight = $('.sideNav .imageWrapper').outerHeight() !== undefined ? $('.sideNav .imageWrapper').outerHeight() : 0
    var calendarHeight = $('.sideNav .cal').outerHeight() !== undefined ? $('.sideNav .cal').outerHeight() : 0
    var elementsHeight = $('.sideNav #stickyElements').outerHeight()
    sideNavHeight = imageHeight + calendarHeight + elementsHeight + 190
  }

  var setHeight = () => {
    getHeight()
    $('.twoColBlock').css('min-height', sideNavHeight)
  }

  setHeight()

  $(window).on('resize', () => {
    getHeight()
    setHeight()
  })
}


// Fonction gérant le calendrier des événements
// documentation: https://bootstrap-datepicker.readthedocs.io/en/latest/index.html
export function calendar(eventsDatesList) {
  $.fn.datepicker.dates['fr'] = {
    days: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
    daysShort: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
    daysMin: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
    months: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
    monthsShort: ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Juin', 'Jui', 'Août', 'Sep', 'Oct', 'Nov', 'Déc'],
    today: 'Aujourd\'hui',
    clear: 'Clear',
    format: 'dd/mm/yyyy',
    titleFormat: 'MM yyyy',
    weekStart: 0
  }

  //var datesEnabled = ["23-6-2019","24-6-2019","17-7-2019"]; // Format de date "j-n-Y"
  var datesEnabled= eventsDatesList.split(',')

  $('.calendar div.cal').datepicker({
    language: 'fr',
    maxViewMode: 0,
    format: 'dd-mm-yyyy',
    todayHighlight: true,
    beforeShowDay: function (date) { // Rendre seulement les dates de la liste d'événements disponibles
      var allDates = date.getDate() + '-' + (date.getMonth() + 1) + '-' + date.getFullYear()
      if(datesEnabled.indexOf(allDates) != -1) return true; else return false
    }
  }).on('changeDate', function(e) {
    var theTimestamp =  Date.parse(e.date)/1000 //Le timestamp du date picker est en millisecondes, il faut le mettre en secondes
    $.request('onChangeDate', {
      data: {dateFilter: theTimestamp},
      update: {'evenementlist::liste':'#eventsWrapper'},
      complete: function (data) { data.then(function(data){ eventsLoaded(data) })},
    })

    //Fermer l'overlay si on est sur le calendrier mobile
    if($( window ).width() <= 1024 ){
      $('#overlay-calendar .wrapper a.close').trigger( 'click' )
    }
  })
}

export function clearCalendar(){
  $('.calendar div.cal').val('').datepicker('update')
}

// Fonction appellée après le clic sur le bouton "Charger plus d'événements"
export function eventsLoaded(data) {
  window.lazyLoad.lazyBackground()
  if (!data['hasMorePages']) $('#eventsMoreBtn').hide(); else $('#eventsMoreBtn').show()
  if(data['currentPage'] != 1){
    var pageSelector = '.eventsPage' + data['currentPage']
    console.log(pageSelector)
    scrollTo(pageSelector,600,-60)
  }
  if(typeof data['date'] !== 'undefined') $('.eventsBlock .select-field').hide(); else $('.eventsBlock .select-field').show()
}

// Fonction appellée après le clic sur le bouton "Charger plus de nouvelles"
export function newsLoaded(data) {
  window.lazyLoad.lazyBackground()
  if (!data['hasMorePages']) $('#newsMoreBtn').hide(); else $('#newsMoreBtn').show()
  if(data['currentPage'] != 1) {
    var pageSelector = '.newsPage' + data['currentPage']
    console.log(pageSelector)
    scrollTo(pageSelector,600,-60)
  }
}

export function copyTextToClipboard(text) {
  if (!navigator.clipboard) {
    fallbackCopyTextToClipboard(text)
    return
  }
  navigator.clipboard.writeText(text).then(function() {
    console.log('Async: Copying to clipboard was successful!')
  }, function(err) {
    console.error('Async: Could not copy text: ', err)
  })
}

export function fallbackCopyTextToClipboard(text) {
  var textArea = document.createElement('textarea')
  textArea.value = text
  document.body.appendChild(textArea)
  textArea.focus()
  textArea.select()

  try
  {
    var successful = document.execCommand('copy')
  }
  catch (err)
  {
    //
  }

  document.body.removeChild(textArea)
  $(document).scrollTop(0)
}
